import _ from 'lodash';
import HttpClient from '@zoom/nws-http-sdk';
import ResponseInterceptor from '@/apis/response-interceptor';
import { isEmptyVal } from '@/utils';

const nwsResult = {
  // call nws api switch
  enableNwsBillingWebApi: _.get(window.newBillingConfig, 'enableNwsBillingWebApi', false),
  nwsPrefix: '/nws/billing-web/1.0',
  pms: ['BillingInformation', 'BillingSubscription', 'SubAccount', 'BillingNws'],
  apiList: [
    { 'url': '/opc/verify/coupon' },
    { 'url': '/opc/validate/coupon' },
  ],
};


export const nwsHttpClientInstance = HttpClient.create({
  tokenUrl: '/nws/common/2.0/nak',
  useToken: nwsResult.enableNwsBillingWebApi && window.SB?.loggedIn,
  tokenParams: {
    pms: nwsResult.pms,
  },
});

// for request interceptor
nwsHttpClientInstance.interceptors.request.use((axiosRequest) => {
  return new Promise((resolve) => {
    const url = axiosRequest.url;
    const { apiList = [], nwsPrefix = "" } = nwsResult;
    const nwsApiObj = _.find(apiList, (item) => item.url === url);

    // enable nws billing api switch and api exist in nws support list
    if (nwsResult.enableNwsBillingWebApi && !isEmptyVal(nwsApiObj)) {
      axiosRequest.url = `${nwsPrefix}${url}`;
    }

    return resolve(axiosRequest);
  });
});

nwsHttpClientInstance.interceptors.response.use(ResponseInterceptor);
